import { NoMarginParagraph } from '@/components/shared/components/LabelValuePair/LabelValuePair.StyledComponents';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
    min-width: ${rem(350)};
`;

export const InputButtonWrapper = styled.div`
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
`;

export const LoggiedInMessage = styled(NoMarginParagraph)`
    font-size: ${rem(14)};
    font-weight: 600;
`;
